import { rfqQuoteDetailsInformationStyles } from "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsInformation";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import UCSColors from "@ucs/Utils/UCSColors";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.detailsGridContainer = {
    gap: 20,
    css: css`
        width: 100%;
        padding: 20px;
        background-color: ${UCSColors.gray10};
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 10px;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    padding: 20px 10px;
                    gap: 0;
                `,
                css`
                    gap: 0;
                `,
            ]);
        }}
    `,
};
rfqQuoteDetailsInformationStyles.jobNameHeadingAndText = {
    heading: {
        size: 13,
        weight: 700,
        color: UCSColors.gray04,
        transform: "uppercase",
        css: css`
            line-height: 16px;
            letter-spacing: 0.1em;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 12px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },

    text: {
        size: 18,
        weight: 400,
        color: UCSColors.gray03,
        css: css`
            line-height: 24px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 17px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
};
rfqQuoteDetailsInformationStyles.customerHeadingAndText = {
    heading: {
        size: 13,
        weight: 700,
        color: UCSColors.gray04,
        transform: "uppercase",
        css: css`
            line-height: 16px;
            letter-spacing: 0.1em;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 12px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },

    text: {
        size: 18,
        weight: 400,
        color: UCSColors.gray03,
        css: css`
            line-height: 24px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 17px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
};
rfqQuoteDetailsInformationStyles.shipToHeadingAndText = {
    heading: {
        size: 13,
        weight: 700,
        color: UCSColors.gray04,
        transform: "uppercase",
        css: css`
            line-height: 16px;
            letter-spacing: 0.1em;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 12px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },

    text: {
        size: 18,
        weight: 400,
        color: UCSColors.gray03,
        css: css`
            line-height: 24px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 17px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
};
rfqQuoteDetailsInformationStyles.expirationDateLabelText = {
    size: 13,
    weight: 700,
    color: UCSColors.gray04,
    transform: "uppercase",
    css: css`
        line-height: 16px;
        letter-spacing: 0.1em;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        font-size: 12px;
                    `,
                ],
                "max",
            );
        }}
    `,
};
